/** Контакты и график — единый источник для Horizons-верстки. */
export const SITE = {
  brand: "avtosklo-kiev.com",
  domain: "avtosklo-kiev.com",
  phonePrimary: "097 927 36 54",
  phoneSecondary: "099 543 74 38",
  phoneE164Primary: "+380979273654",
  phoneE164Secondary: "+380995437438",
  email: "info@avtosklo-kyiv.com",
  address: "м. Київ, вул. Марка Черемшини, 38а",
  hoursWeekdays: "Пн–Пт: 9:00–18:00",
  hoursSaturday: "Сб: 9:00–16:00",
  hoursSunday: "Нд: вихідний",
  telegram: "https://t.me/+380979273654",
  whatsapp: "https://wa.me/380979273654",
  viber: "viber://chat?number=+380979273654",
  tiktok: "https://www.tiktok.com/@autosklo.kiev",
  googleMapsUrl:
    "https://www.google.com/maps/place/%D0%90%D0%B2%D1%82%D0%BE%D0%A1%D0%BA%D0%BB%D0%BE+%D0%9A%D0%B8%D1%97%D0%B2/@50.476666,30.586373,17z",
  mapsEmbed:
    "https://maps.google.com/maps?q=%D0%90%D0%B2%D1%82%D0%BE%D0%A1%D0%BA%D0%BB%D0%BE+%D0%9A%D0%B8%D1%97%D0%B2%2C+%D0%B2%D1%83%D0%BB%D0%B8%D1%86%D1%8F+%D0%9C%D0%B0%D1%80%D0%BA%D0%B0+%D0%A7%D0%B5%D1%80%D0%B5%D0%BC%D1%88%D0%B8%D0%BD%D0%B8%2C+38+%D0%B0%2C+%D0%9A%D0%B8%D1%97%D0%B2%2C+02218&hl=uk&z=17&output=embed",
  heroImage: "/images/hero-bg.jpg",
  galleryWorks: [
    { id: 1, url: "/images/gallery-truck-windshield.jpg", title: "Заміна лобового скла — MAN" },
    { id: 2, url: "/images/gallery-van-windshield.jpg", title: "Заміна лобового скла — Mercedes" },
    { id: 3, url: "/images/gallery-side-van.jpg", title: "Заміна бокових стекол — Sprinter" },
    { id: 4, url: "/images/gallery-rear-audi.jpg", title: "Заміна заднього скла — Audi" },
    { id: 5, url: "/images/gallery-side-sedan.jpg", title: "Заміна бокового скла" },
    { id: 6, url: "/images/gallery-rear-tesla.jpg", title: "Заміна заднього скла — Tesla" },
  ],
  contactImage: "/images/gallery-van-windshield.jpg",
};
